import React from "react";
import GradientButton from "../common/GradientButton";
import Padding from "../common/Padding";
import PlainButton from "../common/PlainButton";
import LightTheme from "../theme/LightTheme";

interface Props {
  title: string;
  msg?: string;
  showCancel: boolean;
  onCancel?: () => void;
  onAccept?: () => void;
  acceptText?: string;
  denyText?: string;
}

const Modal = ({
  title,
  msg,
  showCancel,
  onCancel,
  onAccept,
  acceptText = "OK",
  denyText = "Cancel",
}: Props) => (
  <div className="overlay">
    <div className="modal">
      <div className="content">
        <span className="title">{title}</span>
        {msg && <span className="msg">{msg}</span>}
        <div className="buttons">
          {showCancel && onCancel && (
            <>
              <PlainButton onClick={onCancel}> {denyText} </PlainButton>
              <Padding width={20} />
            </>
          )}
          <GradientButton onClick={onAccept}>{acceptText}</GradientButton>
        </div>
      </div>
    </div>
    <style jsx>{`
      .overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.7);
        transition: opacity 500ms;
        z-index: 998;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
      }
      .modal {
        z-index: 999;
        padding: 10vh 0 10vh 0;
        overflow: hidden;
      }
      .content {
        background-color: #fbfbfc;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 30px 30px;
        border-radius: 5px;
        overflow: auto;
        max-height: 90%;
        width: 450px;
        max-width: 95vw;
      }
      .title {
        font-weight: bold;
        font-size: 2rem;
        color: #3a3a3b;
        padding: 0 0 10px 0;
        text-align: center;
      }
      .msg {
        color: ${LightTheme.font.secondary.color};
        padding: 10px 0;
        font-size: 1.3rem;
        text-align: center;
        white-space: pre-line;
      }
      .buttons {
        padding: 20px 0 0 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
    `}</style>
  </div>
);

export default Modal;
